<template>
    <div>
        <iframe
            :src="this.src"
            @load="load"
            frameborder="0"
            style="height: 80vh; min-height: 500px"
            width="100%"
            id="contentPDF"
        />
        <canvas id="screencast"></canvas>
    </div>
</template>

<script>

    export default {

        name: 'PdfDocumentViewr',

        props: {
            url: String,
        },

        data() {
            return {
                screencastInfo: null,
                screencastConfig: null
            };
        },

        computed: {
            src() {
                // encodeURIComponent é obrigatório: URLs assinadas carregam
                // ?expires=...&signature=... e, sem encode, a query se mistura
                // à do viewer — o pdf.js busca o arquivo sem a signature e o
                // middleware "signed" responde 403.
                return `${location.origin}/app/pdf/view?file=${encodeURIComponent(this.url)}`
            },
        },

        methods: {
            getScreencastInfo() {
                return window.axios
                    .get('/api/app/lesson/content/screencast-info')
                    .then(res => res.data)
                    .catch(err => console.error(err));
            },

            getScreencastConfig() {
                return window.axios
                    .get('/api/app/lesson/content/screencast-config')
                    .then(res => res.data)
                    .catch(err => console.error(err));
            },

            async screencastPost() {
                const screencastInfo = await this.getScreencastInfo();
                return screencastInfo;
            },

            async screencastConfigPost() {
                const screencastConfig = await this.getScreencastConfig();
                return screencastConfig;
            },

            async load() {
                this.screencastInfo = await this.screencastPost();
                this.screencastConfig = await this.screencastConfigPost();

                if (this.screencastConfig.status_lesson_content) {
                    const screencast = document.getElementById('screencast');
                    screencast.style.position = 'absolute';
                    screencast.style.marginTop = '32px';
                    screencast.style.left = '36px';

                    this.drawScreencast();
                }
            },

            drawScreencast() {
                var fontSize = parseInt(this.screencastConfig.fontSize.replace('px', ''));
                let screencastWidth = (this.screencastInfo.length * 5) * (fontSize/10);
                let screencastHeight = fontSize;

                var canvas = document.getElementById('screencast');
                var contentPDF = document.getElementById('contentPDF');

                if (canvas == undefined && contentPDF == undefined) {
                    return;
                }

                //A página atualiza caso o canvas seja removido dela
                if (canvas == undefined && contentPDF != undefined) {
                    window.location.reload();
                } else if (canvas.classList.contains('__web-inspector-hide-shortcut__')){
                    window.location.reload();
                }

                var context = canvas.getContext('2d');
                context.clearRect(0, 0, canvas.width, canvas.height);

                //Redimensionando o canvas de acordo com o tamanho do PDFViewer
                canvas.width = contentPDF.clientWidth - 36;
                canvas.height = contentPDF.clientHeight - 52;

                var positionX = Math.ceil(Math.random()*canvas.width);
                var positionY = Math.ceil(Math.random()*canvas.height);

                if (positionX + screencastWidth > canvas.width) {
                    positionX -= ((positionX + screencastWidth) - canvas.width) + 10;
                }
                if (positionY + screencastHeight > canvas.height) {
                    positionY -= screencastHeight;
                } else if (positionY - screencastHeight < 0) {
                    positionY += screencastHeight;
                }

                context.fillStyle = this.screencastConfig.color;
                context.globalAlpha = this.screencastConfig.opacity/100;
                context.font = `${this.screencastConfig.fontSize} Roboto`;
                context.fillText(this.screencastInfo, positionX, positionY);

                setTimeout(this.drawScreencast, this.screencastConfig.time);
            },
        },

    }
</script>

<style scoped>
    canvas {
        position: absolute;
        top: 40px;
        margin-top: 32px;
        left: 36px;
    }
    @media (max-width: 480px){
        canvas{
            top: 50px !important;
            width: 60vw !important;
            height: auto !important;
        }
    }
</style>